import liff from "@line/liff";
import { selectAuth } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import { getDeployEnvironment } from "@Rocket-Innovation/components/utilities/getDeployEnvironment";
import { useNotify } from "@utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";

export const PageRedirectToExternalFromLiff = () => {
    //page hook
    const hostname = window.location.hostname;

    const { auth } = useSelector(selectAuth);
    const accessToken = auth ?? UserStore((s: any) => s.accessToken);
    const location = useLocation();
    const history = useHistory();
    const { error } = useNotify();
    const searchParams = new URLSearchParams(location.search);
    const domainValue = searchParams.get("domain");
    const pathValue = searchParams.get("path");
    const externalValue = searchParams.get("external");
    const extension = searchParams.get("extension");
    const prefixParam = searchParams.get("prefix");
    const prefix = prefixParam === "false" ? null : hostname.split(".")[0];

    useEffect(() => {
        console.warn("[RedirectToExternalFromLiff] Missing accessToken, refreshing page");
        // if (!accessToken) {
        //     error("กรุณาเข้าสู่ระบบก่อนดำเนินการ || Please login before proceeding");
        //     window.location.reload();
        //     return;
        // }

        if (!domainValue) {
            const missingParams = [];
            if (!domainValue) missingParams.push("domain");

            console.warn(
                `[RedirectToExternalFromLiff] Missing required parameters: ${missingParams.join(
                    ", "
                )}`
            );
            return;
        }

        const env = getDeployEnvironment(hostname);
        const ext = extension ? extension : env === "production" ? "app" : "com";

        const domain = prefix ? `${prefix}.${domainValue}.${ext}` : `${domainValue}.${ext}`;
        const baseUrl = pathValue ? `https://${domain}/${pathValue}` : `https://${domain}`;
        const external = externalValue ? externalValue === "true" : true;
        const params = new URLSearchParams();
        if (accessToken) params.set("token", accessToken);
        if (external) params.set("openExternalBrowser", "1");
        const targetUrl = params.toString() ? `${baseUrl}?${params}` : baseUrl;

        try {
            // Check if we're in LIFF environment
            if (liff.isInClient()) {
                // Use LIFF's openWindow for external links
                liff.openWindow({
                    url: targetUrl,
                    external,
                });
                setTimeout(() => liff.closeWindow(), 1000);
            } else {
                // Fallback for non-LIFF environment
                window.open(targetUrl, "_self");
            }
        } catch (err) {
            // Fallback for older LINE versions
            console.warn("LIFF openWindow failed, using window.open fallback", err);
            window.open(targetUrl, "_blank");
        }
    }, [accessToken, pathValue, domainValue, prefix, externalValue, history]);

    return <StyledContainer />;
};

const StyledContainer = styled.div`
    height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
